import { render } from "./billDetail.vue?vue&type=template&id=136d3fd6"
import script from "./billDetail.vue?vue&type=script&lang=js"
export * from "./billDetail.vue?vue&type=script&lang=js"

import "./billDetail.vue?vue&type=style&index=0&id=136d3fd6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__